const obj = {
    getDateNowText: () =>
    {
        const d = new Date();
        const y = d.getFullYear();
        const m = d.getMonth()+1;
        const day = d.getDay();

        return `${y}${m < 10 ? ('0'+m): m}${day < 10 ? ('0'+day): day}`;
    },
    
    fileNameAdjustment_G: (po_no)=>{

        return `ฉ.1 (พัสดุ) หนังสือแจ้งสิทธิ์การเรียกค่าปรับ_${po_no}_${obj.getDateNowText()}`
    },
    fileNameAdjustment_C: (po_no)=>{
        return `(พาณิชย์) หนังสือแจ้งสงวนสิทธิ์การเรียกค่าปรับ_${po_no}_${obj.getDateNowText()}`
    },
    fileNameReservedAdjustment_G:  (po_no)=>{
        return `ฉ.2 (พัสดุ) หนังสือแจ้งสงวนสิทธิ์การเรียกค่าปรับ_${po_no}_${obj.getDateNowText()}`
    },
    fileNameReservedAdjustment_C:  (po_no)=>{
        return `(พาณิชย์) หนังสือแจ้งสงวนสิทธิ์การเรียกค่าปรับ_${po_no}_${obj.getDateNowText()}`
    }
}

export default obj;